module.exports = __webpack_public_path__ + "static/media/rating-star-average-icon.07efefe9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/rating-star-average-icon.svg
// module id = 687
// module chunks = 0